import { memo } from 'react';
import styles from './Advt.module.css';
import { iconsSources } from '../../helpers/icons';
import { formatPhoneNumber } from '../../helpers/titreHelper';

const Advt = memo(({ advtInfo, paddingQR }) => {
  const colorChan = {
    sms: 'chan-sms',
    facebook: 'chan-facebook',
    vkgroup: 'chan-vkgroup', // сообщение вк
    telegram: 'chan-telegram',
    telegrambot: 'chan-telegrambot',
    viber: 'chan-viber',
    whatsapp: 'chan-whatsapp',
    livechat: 'chan-livechat',
    fbinstagram: 'chan-fbinstagram',
    vkcomments: 'chan-vkcomm', // повторение
    facebookcomments: 'chan-facebookcomments',
    smsMoney: 'chan-smsmoney',
    vk: 'chan-vkcomm', // комментарий вк
    vkcomm: 'chan-vkcomm', // комментарий вк
    ok: 'chan-ok',
    okgroup: 'chan-okgroup',
  };

  // const colorBlockQR1 =
  //   advtInfo.qrTitle1 && colorChan[advtInfo.qrTitle1.toLowerCase()];
  // const colorBlockQR2 =
  //   advtInfo.qrTitle2 && colorChan[advtInfo.qrTitle2.toLowerCase()];

  let phoneNumberFormat = formatPhoneNumber(advtInfo.number, '-');

  return (
    <div className={styles.wrapper}>
      <div className={styles.info}>
        {advtInfo.label && (
          <div className={styles.title}>
            {advtInfo.label.split('\n').map((el) => (
              <span key={el}>{el}</span>
            ))}
          </div>
        )}
        <div className={styles.phoneWrapper}>
          <div className={styles.socials}>
            {advtInfo.socials &&
              advtInfo.socials.map((item) => (
                <div key={item} className={styles.icon}>
                  <img src={iconsSources[item]} alt={item} />
                </div>
              ))}
          </div>
          {phoneNumberFormat && (
            <div className={styles.number}>{phoneNumberFormat}</div>
          )}
        </div>
      </div>
      {(advtInfo.qrCode1 || advtInfo.qrCode2) && (
        <div className={styles.qrWrapper}>
          {advtInfo.qrCode1 && (
            <div className={styles.qrBlock}>
              {advtInfo.qrTitle1 && (
                <span className={`${styles.qrTitle}`}>{advtInfo.qrTitle1}</span>
              )}
              <div
                className={styles.qrCode}
                style={{
                  padding: `${paddingQR}rem`,
                  background: paddingQR === '0' && 'none',
                }}>
                <img
                  src={advtInfo.qrCode1}
                  alt="qrCode1"
                  style={{
                    borderRadius: paddingQR === '0' ? '1.5rem' : 'none',
                  }}
                />
              </div>
            </div>
          )}
          {advtInfo.qrCode2 && (
            <div className={styles.qrBlock}>
              {advtInfo.qrTitle2 && (
                <span className={`${styles.qrTitle}`}>{advtInfo.qrTitle2}</span>
              )}

              <div
                className={styles.qrCode}
                style={{
                  padding: `${paddingQR}rem`,
                  background: paddingQR === '0' && 'none',
                }}>
                <img
                  src={advtInfo.qrCode2}
                  alt="qrCode2"
                  style={{
                    borderRadius: paddingQR === '0' ? '1.5rem' : 'none',
                  }}
                />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
});

export default Advt;
